var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	803: () => (loadSingletonVersion("default", "react-dom", true, [1,18,3,1], () => (() => (__webpack_require__(879))))),
	1874: () => (loadSingletonVersion("default", "@emotion/react", false, [1,11,11,4], () => (Promise.all([__webpack_require__.e(9577), __webpack_require__.e(5631)]).then(() => (() => (__webpack_require__(8012))))))),
	8752: () => (loadSingletonVersion("default", "react-transition-group", false, [1,4,4,5], () => (__webpack_require__.e(9140).then(() => (() => (__webpack_require__(9140))))))),
	5983: () => (loadSingletonVersion("default", "@mui/material", false, [1,5,16,0], () => (Promise.all([__webpack_require__.e(9577), __webpack_require__.e(6968), __webpack_require__.e(3695), __webpack_require__.e(8646), __webpack_require__.e(4602), __webpack_require__.e(803), __webpack_require__.e(3465), __webpack_require__.e(1874), __webpack_require__.e(8752)]).then(() => (() => (__webpack_require__(4602))))))),
	1200: () => (loadSingletonVersion("default", "react-i18next", false, [1,13,5,0], () => (__webpack_require__.e(7491).then(() => (() => (__webpack_require__(7491))))))),
	1947: () => (loadSingletonVersion("default", "jsencrypt", false, [1,3,3,2], () => (__webpack_require__.e(6201).then(() => (() => (__webpack_require__(6201))))))),
	2894: () => (loadSingletonVersion("default", "date-fns", false, [1,2,30,0], () => (__webpack_require__.e(8866).then(() => (() => (__webpack_require__(6485))))))),
	3895: () => (loadSingletonVersion("default", "i18next", false, [1,23,11,5], () => (__webpack_require__.e(3745).then(() => (() => (__webpack_require__(3745))))))),
	5414: () => (loadSingletonVersion("default", "@el2/theme", false, [2,0,1,22], () => (Promise.all([__webpack_require__.e(8553), __webpack_require__.e(7915)]).then(() => (() => (__webpack_require__(8553))))))),
	7638: () => (loadSingletonVersion("default", "@el2/verlag-font", false, [2,0,1,13], () => (__webpack_require__.e(6282).then(() => (() => (__webpack_require__(6282))))))),
	8365: () => (loadSingletonVersion("default", "i18next-browser-languagedetector", false, [1,7,2,1], () => (__webpack_require__.e(1656).then(() => (() => (__webpack_require__(9275))))))),
	0: () => (loadSingletonVersion("default", "@mui/lab", false, [1,5,0,0,,"alpha",171], () => (Promise.all([__webpack_require__.e(9577), __webpack_require__.e(3695), __webpack_require__.e(8066), __webpack_require__.e(803), __webpack_require__.e(3465), __webpack_require__.e(1874), __webpack_require__.e(8752)]).then(() => (() => (__webpack_require__(8066))))))),
	5966: () => (loadSingletonVersion("default", "@el2/icons", false, [2,0,2,3], () => (__webpack_require__.e(14).then(() => (() => (__webpack_require__(14))))))),
	3465: () => (loadSingletonVersion("default", "@emotion/styled", false, [1,11,11,5], () => (__webpack_require__.e(4978).then(() => (() => (__webpack_require__(2597))))))),
	1705: () => (loadSingletonVersion("default", "react-router-dom", false, [1,6,24,1], () => (__webpack_require__.e(6456).then(() => (() => (__webpack_require__(6456))))))),
	4510: () => (loadSingletonVersion("default", "buffer", false, [1,6,0,3], () => (__webpack_require__.e(8381).then(() => (() => (__webpack_require__(8381))))))),
	5247: () => (loadSingletonVersion("default", "remark-gfm", false, [1,3,0,1], () => (Promise.all([__webpack_require__.e(704), __webpack_require__.e(2542)]).then(() => (() => (__webpack_require__(2542))))))),
	8134: () => (loadSingletonVersion("default", "react-markdown", false, [1,8,0,7], () => (Promise.all([__webpack_require__.e(8067), __webpack_require__.e(704), __webpack_require__.e(3316)]).then(() => (() => (__webpack_require__(3316))))))),
	9257: () => (loadSingletonVersion("default", "rehype-raw", false, [1,6,1,1], () => (Promise.all([__webpack_require__.e(8067), __webpack_require__.e(9329)]).then(() => (() => (__webpack_require__(9329))))))),
	533: () => (loadSingletonVersion("default", "react", true, [1,18,3,1], () => (() => (__webpack_require__(9198)))))
};
var initialConsumes = [533];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"779": [
		1200,
		1947,
		2894,
		3895,
		5414,
		7638,
		8365
	],
	"803": [
		803
	],
	"1063": [
		1705,
		4510,
		5247,
		8134,
		9257
	],
	"1874": [
		1874
	],
	"3465": [
		3465
	],
	"5983": [
		5983
	],
	"7915": [
		0,
		5966
	],
	"8752": [
		8752
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}